import { ApplicationState } from 'app/fieldapp/store/store'

export const getRefreshToken = (state: ApplicationState): string | undefined =>
  state.auth.refreshToken
